<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2026-03-05 14:44:52
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2026-03-16 08:50:46
 * @FilePath: \vue-hd-ota\src\views\code\ScanRecord.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>

        <div class="search_panel">
            <a-input v-model:value="search.ble_name" allowClear placeholder="蓝牙名称" style="width: 200px;margin-right: 10px;" @change="handleInputChangeSearch"/>
            <a-input v-model:value="search.code" allowClear placeholder="速牛码" style="width: 200px;margin-right: 10px;" @change="handleInputChangeSearch"/>
            <a-input v-model:value="search.request_ip" allowClear placeholder="请求IP地址" style="width: 200px;margin-right: 10px;" @change="handleInputChangeSearch"/>

            <a-button type="primary" size="small" class="operate_btn" @click="handleSearch">
                <component :is="$antIcons['SearchOutlined']"></component>
                {{$t('base.search')}}
            </a-button>
        </div>

        <Table
            :table="table"
            @handleChangePagination="handleChangePagination"
        >
            <!-- 表头自定义按钮 -->
            <!-- <template v-slot:operateBtn>
                <a-button type="primary" size="small" class="operate_btn" @click="handle('add')">
                    <component :is="$antIcons['PlusOutlined']"></component>
                    {{$t('base.add')}}
                </a-button>
            </template> -->
            
            <!-- 表格列自定义列内容 -->
            <!-- <template v-slot:customCol="{props}">
                <template v-if="props.column.key === 'status'">
                    <div class="editable-cell"> 
                        <a-tag
                            :color="props.record.status_val === 0 ? 'green' : 'red'"
                        >{{ props.record.status }}</a-tag>
                    </div>
                </template>
            </template> -->

            <!-- 表格操作按钮 -->
            <!-- <template v-slot:tableAction="{props}">
                <template v-if="props.column.key === 'action'">
                    <a-button type="link" size="small" :disabled="props.record.status_val == 1" style="margin-right:10px" @click="handle('stop',props.record)">
                        {{$t('notice.cancel')}}
                    </a-button>
                    <a-button type="link" size="small" style="margin-right:10px" @click="handle('detail',props.record)">
                        {{$t('notice.detail')}}
                    </a-button>
                </template>
            </template> -->
        </Table>
    </div>
</template>

<script setup>
    import { onMounted, ref, reactive, createVNode, watch } from "vue";
    import Table from "@/components/Table.vue";
    import SearchForm from "@/components/Form.vue";
    import { useRouter } from "vue-router";
    // import { QueryForm } from './js/formConfig.js';
    import { useI18n } from 'vue-i18n';
    import { message, Modal } from 'ant-design-vue';
    import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
    import { CodeApi } from '@/api/CodeApi.js';
    import { debounce } from 'lodash-es';

    const { t } = useI18n()
    const router = useRouter()

    const table = ref({
        data: [],
        columns: [
            {
                title: '#',
                dataIndex: 'serial',
                key: 'serial',
                width: 70,
                resizable: true,
                fixed: 'left',
            },
            {
                title: '蓝牙名称',
                dataIndex: 'ble_name',
                key: 'ble_name',
                // width: 100,
                resizable: true,
            },
            {
                title: '速牛码',
                dataIndex: 'code',
                key: 'code',
                // width: 200,
                resizable: true,
                ellipsis :true,
            },
            {
                title: '请求IP地址',
                dataIndex: 'request_ip',
                key: 'request_ip',
                // width: 100,
                resizable: true,
            },
            {
                title: '请求时间',
                dataIndex: 'request_create_time_str',
                key: 'request_create_time_str',
                // width: 100,
                resizable: true,
            },

            {
                title: '国家',
                dataIndex: 'country',
                key: 'country',
                // width: 200,
                resizable: true,
                ellipsis :true,
            },
            {
                title: '国家编码',
                dataIndex: 'country_code',
                key: 'country_code',
                // width: 100,
                resizable: true,
            },
            {
                title: '省份',
                dataIndex: 'province',
                key: 'province',
                // width: 100,
                resizable: true,
            },
            {
                title: '城市',
                dataIndex: 'city',
                key: 'city',
                // width: 200,
                resizable: true,
                ellipsis :true,
            },
            {
                title: '经度',
                dataIndex: 'longitude',
                key: 'longitude',
                // width: 100,
                resizable: true,
            },
            {
                title: '纬度',
                dataIndex: 'latitude',
                key: 'latitude',
                // width: 100,
                resizable: true,
            },
            // {
            //     title: t('base.operate'),
            //     key: 'action',
            //     fixed: 'right',
            //     width: 130,
            //     resizable: true,
            // },
        ],
        configs: {
            table: {
                pagination: {
                    total: 0,
                },
                rowClassName:(record, index) => (index % 2 === 1 ? 'table-striped' : null)
            },
            scroll: {
                x: 1500,
                y: 550,//设置表格高度，固定表头
            },
            rowSelection: false,
            loading: true,
            pagination: {
                hideOnSinglePage: false,
                position: ['bottomLeft'],
                responsive: true,// size 未指定时，根据屏幕宽度自动调整尺寸
                current: 1,
                pageSize: 10,
                pageSizeOptions: ['10', '20', '50'],
                total: 0,
                showTotal: () => t('base.total') + ` ${table.value.configs.pagination.total} ` + t('base.row')
            },
            operateBtn: {
                showSearch: false,
                showAdd: false,
            }
        },
    })

    const search = ref({
        ble_name: '',
        code: '',
        request_ip: '',
    })


    const handleChangePagination = (config) => {
        table.value.configs.pagination.current = config.current
        table.value.configs.pagination.pageSize = config.pageSize
        getScanRecord()
    } 

    const handleSearch = () => {
        table.value.configs.pagination.current = 1
        getScanRecord()
    }

    const handleInputChangeSearch = (key) => {
        table.value.configs.pagination.current = 1
        getScanRecord()
    }

    const getScanRecord = async () => {
        let param = {
            ble_name: search.value.ble_name.trim(),
            code: search.value.code.trim(),
            request_ip: search.value.request_ip.trim(),
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true

        let res = await CodeApi.getInstance().getScanRecord(param, page_num, page_size)
        if(res.code == 0){
            res.data.records.forEach((item,index) => {
                item.serial = index + 1
                item.country = item.country == undefined? '-' : item.country
                item.country_code = item.country_code == undefined? '-' : item.country_code
                item.province = item.province == undefined? '-' : item.province
                item.city = item.city == undefined? '-' : item.city
                item.longitude = item.longitude == undefined? '-' : item.longitude
                item.latitude = item.latitude == undefined? '-' : item.latitude

            })
            table.value.data = res.data.records
            table.value.configs.pagination.total = res.data.total
            table.value.configs.loading = false
        }else{
            message.error(res.msg)
        }
    }

      

    onMounted(() => {
        getScanRecord()
    })
</script>

<style lang="scss" scoped>
.search_panel{
    margin-bottom: 10px;
}
</style>